import { createReducer, on } from '@ngrx/store';
import { AppActions } from './app.actions';
import { AppState, initialAppState } from './app.state';

export const appReducer = createReducer(
  initialAppState,

  on(
    AppActions.changeLanguage,
    (state, { language }): AppState => ({
      ...state,
      currentLanguage: language,
    }),
  ),
  on(
    AppActions.contextChanged,
    (state): AppState => ({
      ...state,
      contextVersion: state.contextVersion + 1,
    }),
  ),
);
